module.exports = __webpack_public_path__ + "img/11.3c0e3ea5.jpg";